import styled from 'styled-components'
import { FlexContainer } from '../FlexContainer'

export default styled(FlexContainer)`
  padding: 1rem;
  width: 100%;
`
